import { render } from "./ViewWorkflow.vue?vue&type=template&id=547fe005"
import script from "./ViewWorkflow.js?vue&type=script&lang=js&external"
export * from "./ViewWorkflow.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__